import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class MasterSalesReportService {
  constructor(private http: HttpClient) { }

  
  getOrderSourceList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/order-source/get', requestData);

  }

  exportMasterSalesReport(data:any): Observable<any> {
    return this.http.post(
      environment.baseUrl+'/hq/reports/master-sales-report', 
      data, 
      { responseType: 'blob' }
);
  }
}
